/**
 * First-login routing for admin-onboarded vendors.
 *
 * The admin-onboard-vendor edge function stamps user_metadata.vendor_onboarding
 * on the accounts it creates. Both post-login decision points — the Auth page
 * submit handler and the AuthContext session-restore effect — divert flagged
 * vendors to /onboarding before any normal destination. The flag is cleared
 * server-side by /api/onboarding/complete once the vendor finishes, so this
 * only ever intercepts the first login.
 */

export const VENDOR_ONBOARDING_PATH = '/onboarding';

export interface VendorOnboardingUser {
  user_metadata?: {
    vendor_onboarding?: boolean;
  } | null;
}

/**
 * Returns '/onboarding' when the user still owes first-login onboarding, or
 * null when the caller should proceed with its normal destination.
 */
export function vendorOnboardingPath(
  user: VendorOnboardingUser | null | undefined,
): string | null {
  return user?.user_metadata?.vendor_onboarding === true ? VENDOR_ONBOARDING_PATH : null;
}
